import divColor from "./div-color.vue";
import textAfter from "./text-after.vue";
import textFormat from "./text-format.vue";
export { divColor, textAfter, textFormat };
